import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sub_menu_01" }
const _hoisted_2 = { class: "snb" }

import { computed } from "vue";
import { useStore } from "vuex";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useAuth } from "@/composables/useAuth";

export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

const { isLoggedIn } = useAuth();

const store = useStore();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          class: _normalizeClass({ active: _ctx.$route.path.includes(_unref(USER_ROUTES).SUB61) })
        }, [
          _createVNode(_component_router_link, {
            to: `${_unref(USER_ROUTES).About.Path}`
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("인사말씀")
            ])),
            _: 1
          }, 8, ["to"])
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass({ active: _ctx.$route.path.includes(_unref(USER_ROUTES).SUB62) })
        }, [
          _createVNode(_component_router_link, {
            to: `${_unref(USER_ROUTES).About.Profile.Path}`
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("대표이사 프로필")
            ])),
            _: 1
          }, 8, ["to"])
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass({ active: _ctx.$route.path.includes(_unref(USER_ROUTES).SUB63) })
        }, [
          _createVNode(_component_router_link, {
            to: `${_unref(USER_ROUTES).About.Philosophy.Path}`
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("철학")
            ])),
            _: 1
          }, 8, ["to"])
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass({ active: _ctx.$route.path.includes(_unref(USER_ROUTES).SUB64) })
        }, [
          _createVNode(_component_router_link, {
            to: `${_unref(USER_ROUTES).About.Vision.Path}`
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("비전과 미션")
            ])),
            _: 1
          }, 8, ["to"])
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass({ active: _ctx.$route.path.includes(_unref(USER_ROUTES).SUB65) })
        }, [
          _createVNode(_component_router_link, {
            to: `${_unref(USER_ROUTES).About.OrgChart.Path}`
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("조직도")
            ])),
            _: 1
          }, 8, ["to"])
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass({ active: _ctx.$route.path.includes(_unref(USER_ROUTES).SUB66) })
        }, [
          _createVNode(_component_router_link, {
            to: `${_unref(USER_ROUTES).About.Map.Path}`
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("오시는 길")
            ])),
            _: 1
          }, 8, ["to"])
        ], 2)
      ])
    ])
  ]))
}
}

})